import { cn } from "../../../../src/lib/utils";

interface PageTitleProps {
  title: string;
  className?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, className }) => {
  return (
    <h1
      className={cn(
        "block text-2xl font-semibold leading-8 text-[#0A0A0A] mb-6",
        className
      )}
    >
      {title}
    </h1>
  );
};

export default PageTitle;